import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../../utils/styles';

const StyledMissingBillsTab = styled(Space)`
  position: relative;
  width: 100%;

  & > .ant-space-item {
    &:not(:nth-of-type(2)) {
      padding: 0 24px;
    }
  }
`;

const StyledMissingBillsTabDescription = styled.div`
  ${typographyStyles.body.regular};
  background-color: ${props => props.theme.colors.neutral_3};
  color: ${props => props.theme.colors.neutral_8};
  line-height: 22px;
  padding: 8px 24px;
  text-align: center;
`;

const StyledMissingBillsTabRowIcon = styled.span`
  display: inline-block;

  &:hover {
    cursor: pointer;
  }

  svg {
    height: 24px;
    width: 24px;
  }
`;

export {
  StyledMissingBillsTab,
  StyledMissingBillsTabDescription,
  StyledMissingBillsTabRowIcon
}
